const BSKT_LOP_HOC_ENDPOINT = "BSKTLopHoc";

export const lopHocApi = {
    GET_LIST: `${BSKT_LOP_HOC_ENDPOINT}/get-list`,
    CREATE_OR_UPDATE: `${BSKT_LOP_HOC_ENDPOINT}/create-or-update`,
    DELETE: (id: number) => `${BSKT_LOP_HOC_ENDPOINT}/delete/${id}`,
    GET_LICH_HOC: (id: number) => `${BSKT_LOP_HOC_ENDPOINT}/get-lich-hoc/${id}`,
    GET_LICH_THI: (id: number) => `${BSKT_LOP_HOC_ENDPOINT}/get-lich-thi/${id}`,
    SAVE_LICH_HOC: `${BSKT_LOP_HOC_ENDPOINT}/save-lich-hoc`,
    SEND_LICH_HOC_EMAIL: (id: number) => `${BSKT_LOP_HOC_ENDPOINT}/send-lich-hoc-email/${id}`,
    SAVE_LICH_THI: `${BSKT_LOP_HOC_ENDPOINT}/save-lich-thi`,
    SEND_LICH_THI_EMAIL: (id: number) => `${BSKT_LOP_HOC_ENDPOINT}/send-lich-thi-email/${id}`,
    MO_LOP: `${BSKT_LOP_HOC_ENDPOINT}/mo-lop`,
    GET_NGANH_GAN_DUNG_LIST: `${BSKT_LOP_HOC_ENDPOINT}/get-nganh-gan-dung-list`,
    GET_MON_HOC_BY_NGANH_GAN_DUNG: (id: number) =>
        `${BSKT_LOP_HOC_ENDPOINT}/get-mon-hoc-by-nganh-gan-dung/${id}`,
};
